"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addCommonInfoToDynatraceTracker = exports.addCommonInfoToWrapupTracker = exports.addCommonInfoToTealiumTracker = exports.addCommonInfoToDomEventsTracker = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const tracker_utils_1 = require("./tracker.utils");
const contactCenter_1 = require("../contactCenter");
const updateTrackerConfig = (config, tracker) => {
    let configData = undefined;
    if (tracker instanceof web_ui_framework_1.DomEventsTracker) {
        configData = config.domEventsTracker?.configData;
    }
    else if (tracker instanceof web_ui_framework_1.TealiumTracker) {
        configData = config.tealiumTracker?.configData;
    }
    else if (tracker instanceof web_ui_framework_1.DynatraceTracker) {
        configData = config.dynatraceTracker?.configData;
    }
    else {
        configData = config.wrapupTracker?.configData;
    }
    if (!configData) {
        throw new Error(`${tracker.constructor.name} config must be informed`);
    }
    tracker.updateConfig(configData);
};
// TODO: refactor this functions to use a common function
const addCommonInfoToDomEventsTracker = async (config, tracker) => {
    if (!(0, contactCenter_1.isContactCenter)() && config.domEventsTracker && config.domEventsTracker.getCommonDomEventsConfig) {
        const additionalData = await config.domEventsTracker.getCommonDomEventsConfig(config);
        const newConfig = (0, tracker_utils_1.mergeDomEventsTrackerConfig)(config, additionalData);
        updateTrackerConfig(newConfig, tracker);
    }
};
exports.addCommonInfoToDomEventsTracker = addCommonInfoToDomEventsTracker;
const addCommonInfoToTealiumTracker = async (config, tealiumTracker) => {
    if (!(0, contactCenter_1.isContactCenter)() && config.tealiumTracker && config.tealiumTracker.getCommonTealiumConfig) {
        const additionalData = await config.tealiumTracker.getCommonTealiumConfig(config);
        const newConfig = (0, tracker_utils_1.mergeTealiumTrackerConfig)(config, additionalData);
        updateTrackerConfig(newConfig, tealiumTracker);
    }
};
exports.addCommonInfoToTealiumTracker = addCommonInfoToTealiumTracker;
const addCommonInfoToWrapupTracker = (config, wrapupTracker) => {
    if ((0, contactCenter_1.isContactCenter)() && config?.wrapupTracker?.getCommonWrapupConfig) {
        const additionalData = config.wrapupTracker.getCommonWrapupConfig(config);
        const newConfig = (0, tracker_utils_1.mergeWrapupTrackerConfig)(config, additionalData);
        updateTrackerConfig(newConfig, wrapupTracker);
    }
};
exports.addCommonInfoToWrapupTracker = addCommonInfoToWrapupTracker;
const addCommonInfoToDynatraceTracker = (config, dynatraceTracker) => {
    if (config?.dynatraceTracker?.getCommonDynatraceConfig) {
        const additionalData = config.dynatraceTracker.getCommonDynatraceConfig(config);
        const newConfig = (0, tracker_utils_1.mergeDynatraceTrackerConfig)(config, additionalData);
        updateTrackerConfig(newConfig, dynatraceTracker);
    }
};
exports.addCommonInfoToDynatraceTracker = addCommonInfoToDynatraceTracker;
//# sourceMappingURL=tracker.js.map